import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import usePageSEO from '@/hooks/usePageSEO';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  const location = useLocation();

  usePageSEO({
    title: '人人影视：高清免费在线观看-人人影视免费影视 | 高清不缓冲电视剧全集',
    description: '人人影视高清免费在线观看，覆盖热门电视剧全集、电影大全，不缓冲秒播极速播放。汇聚海量免费影视资源，高清画质免付费，即点即看。',
    keywords: '人人影视,人人影视高清,人人影视免费,人人影视在线观看,人人影视不缓冲,人人影视免费影视,高清免费在线观看,免费电视剧全集,不缓冲秒播,免费电影大全,高清影视',
    canonicalPath: '/',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': '人人影视：高清免费在线观看-人人影视免费影视 | 高清不缓冲电视剧全集',
      'description': '人人影视高清免费在线观看，覆盖热门电视剧全集、电影大全，不缓冲秒播极速播放。',
      'url': 'https://www.renrentv.com/',
      'isPartOf': {
        '@type': 'WebSite',
        'name': '人人影视',
        'url': 'https://www.renrentv.com/',
      },
    },
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <TrendingSection />
        <LatestSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}